const state = {
  selected: null,
  list: [
    {
      id: 1,
      name: '信義安和站A站',
      state: 1,
      power: 'FUNCTIONAL',
      address: '台北市大安區',
      maintenanceDept: '台北市大安區',
      position: { lat: 25.0226511, lng: 121.5534588 },
      bikeRacks: 25,
      available: 10,
      startDate: '2020/02/20',
      dispatch: false,
      suspended: false
    },
    {
      id: 2,
      name: '信義安和站B站',
      state: 1,
      power: 'FUNCTIONAL',
      address: '台北市大安區',
      maintenanceDept: '台北市大安區',
      position: { lat: 25.0230399, lng: 121.5481373 },
      bikeRacks: 25,
      available: 5,
      startDate: '2020/02/20',
      dispatch: false,
      suspended: false
    },
    {
      id: 3,
      name: '信義安和站C站',
      state: 1,
      power: 'FUNCTIONAL',
      address: '台北市大安區',
      maintenanceDept: '台北市大安區',
      position: { lat: 25.0152199, lng: 121.5430373 },
      bikeRacks: 25,
      available: 20,
      startDate: '2020/02/20',
      dispatch: false,
      suspended: false
    }
  ]
}

const getters = {
  list ({ list }) {
    return list
  },
  currentStation ({ selected, list }) {
    if (!selected) return null
    return list.find(station => station.id === selected)
  }
}

const actions = {
  select ({ commit }, id) {
    commit('SET_SELECTED', id)
  },
  clearSelected ({ commit }, id) {
    commit('SET_SELECTED', null)
  },
  preset ({ getters, dispatch }) {
    const { list } = getters
    const presetStation = list[0]
    dispatch('select', presetStation.id)
  }
}

const mutations = {
  SET_SELECTED (state, value) {
    state.selected = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
